export default class EmailValidation{
	static get REG_EXP_EMAIL_RFC_5322(){
		return /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	}
	static emailRFC5322(value){
		return EmailValidation.REG_EXP_EMAIL_RFC_5322.test(value);
	}
}